import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemLanguageCodeModel } from '../models/system-language-code-model';
import { SystemLanguageCodesService } from '../system-language-codes.service';

@Component({
    selector: 'edit-system-language-code',
    standalone: true,
    imports: [CommonModule, FormsModule],
    providers: [SystemLanguageCodesService],
    templateUrl: './edit-system-language-code.component.html'
})
export class EditSystemLanguageCodeComponent implements OnInit {
    @Input() languageCode: SystemLanguageCodeModel;
    @Input() isNew: boolean = false;

    public model: SystemLanguageCodeModel;
    public isSaving: boolean = false;
    public errorMessage: string = '';

    constructor(
        public activeModal: NgbActiveModal,
        private systemLanguageCodesService: SystemLanguageCodesService
    ) {}

    ngOnInit(): void {
        if (this.isNew) {
            this.model = {
                id: 0,
                languageCode_ISO639_1: '',
                languageCode_ISO639_3: '',
                languageName: ''
            };
        } else {
            this.model = { ...this.languageCode };
        }
    }

    public save(): void {
        this.isSaving = true;
        this.errorMessage = '';

        if (this.isNew) {
            this.systemLanguageCodesService.create(this.model).subscribe({
                next: (result) => {
                    this.activeModal.close({ action: 'save', data: result });
                },
                error: (error) => {
                    this.isSaving = false;
                    this.errorMessage = error?.error?.message || error?.message || 'Failed to create the language code. Please try again.';
                }
            });
        } else {
            this.systemLanguageCodesService.update(this.languageCode.id, this.model).subscribe({
                next: (result) => {
                    this.activeModal.close({ action: 'save', data: result });
                },
                error: (error) => {
                    this.isSaving = false;
                    this.errorMessage = error?.error?.message || error?.message || 'Failed to update the language code. Please try again.';
                }
            });
        }
    }

    public cancel(): void {
        this.activeModal.dismiss('cancel');
    }
}
